import Vuetify from "vuetify";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { STATE } from "@/shared/constants/GeneralConstants";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { ActionGeneralRules } from "../../models/actions.model";
import {
  ACTIONS,
  COLLECTIONS_WITHOUT_SERVICES,
  GENERAL_RULES_CONSTANTS,
  RULES_COLLECTIONS,
  SERVICE_FIELDS,
  TASK_FORM_LABELS
} from "../../constants/GeneralRulesConstants";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { ListService } from "@/modules/List/services/ListService";
import { ChangeStateServiceModel } from "../../models/ChangeStateService.model";
import { ConditionGeneralRules } from "../../models/condition.model";
import { SERVICE_STATES } from "@/modules/Services/constants/ServicesConstants";

Vue.use(Vuetify);
@Component({
  name: "ChangeStateService",
  components: { DynamicSelect }
})
export default class ChangeStateService extends Vue {
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() listService!: ListService;

  @Prop() showChangeServiceStateModal!: boolean;
  @Prop() actionToEdit!: ActionGeneralRules;
  @Prop() isToEdit!: boolean;
  @Prop() collection!: string;
  @Prop() conditions!: ConditionGeneralRules[];

  ACTIONS = ACTIONS;
  TITLES = GENERAL_RULES_CONSTANTS.TITTLES;
  CHANGE_SERVICE_STATE_NOTE =
    GENERAL_RULES_CONSTANTS.MESSAGES.CHANGE_SERVICE_STATE_NOTE;
  TASK_FORM_LABELS = TASK_FORM_LABELS;
  serviceStateFieldsValidation = false;
  cardClass = STYLE_CLASSES.CARD;
  FieldListServiceStateModel = [] as DynamicSelectData[];
  FieldListServiceTemplateModel = [] as DynamicSelectData[];
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  FieldSelectConfigServiceTemplate: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: GENERAL_RULES_CONSTANTS.LABEL.SELECT_SERVICE,
    hideDetails: false,
    rules: COLLECTIONS_WITHOUT_SERVICES.includes(this.collection)
      ? [FORM_VALIDATORS.REQUIRED_LIST, FORM_VALIDATORS.REQUIRED_OBJECT_FILLED]
      : [],
    attach: false
  };

  FieldSelectConfigServiceState: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: GENERAL_RULES_CONSTANTS.LABEL.SELECT_SERVICE_STATE,
    hideDetails: false,
    rules: [
      FORM_VALIDATORS.REQUIRED_LIST,
      FORM_VALIDATORS.REQUIRED_OBJECT_FILLED
    ],
    attach: false
  };

  async mounted() {
    this.getServiceTemplates();
    await this.getServiceStates();
    if (
      this.isToEdit &&
      Object.keys(
        this.actionToEdit.changeStateService as ChangeStateServiceModel
      ).length > 0
    ) {
      this.preloadInfo();
    }
  }
  preloadInfo() {
    if (this.actionToEdit.changeStateService!.serviceTemplate.length > 0) {
      this.FieldListServiceTemplateModel = [
        {
          id: this.actionToEdit.changeStateService?.serviceTemplate[0]
            ?.id as string,
          name: this.actionToEdit.changeStateService?.serviceTemplate[0]
            ?.name as string
        }
      ];
    }

    const state = this.FieldSelectConfigServiceState.listAll.find(
      state => state.id === this.actionToEdit.changeStateService?.state[0].id
    );
    this.FieldListServiceStateModel = [
      {
        id: this.actionToEdit.changeStateService?.state[0].id as string,
        name: state!.name as string
      }
    ];
  }

  async getServiceTemplates() {
    try {
      const response = await this.serviceTemplateService.getAllActiveServiceTemplate(
        STATE.ACTIVE
      );
      if (response.code === Http.Found && response.data) {
        const serviceTemplates = response.data;
        this.FieldSelectConfigServiceTemplate.listAll = serviceTemplates.map(
          item => {
            return { id: item.id as string, name: item.internalName as string };
          }
        );
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async save() {
    const serviceTemplate = await this.valitdateServiceTemplateField(
      this.FieldListServiceTemplateModel
    );
    if (
      serviceTemplate.length > 0 &&
      (await this.isSameServiceOfCondition(serviceTemplate[0].id as string))
    ) {
      Snackbar.popError(
        GENERAL_RULES_CONSTANTS.MESSAGES.NOT_ASSIGN_SAME_SERVICE_OF_CONDITION
      );
      return;
    }
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SAVE_SERVICE_STATE_MODAL, {
      serviceTemplate: serviceTemplate,
      state: this.FieldListServiceStateModel
    });
  }

  async valitdateServiceTemplateField(
    serviceTemplateField: DynamicSelectData[]
  ): Promise<DynamicSelectData[]> {
    if (serviceTemplateField.length > 0 && serviceTemplateField[0].id) {
      return serviceTemplateField;
    }
    return [];
  }

  cancel() {
    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.CLOSE_SERVICE_STATE_MODAL,
      false
    );
  }

  async getServiceStates() {
    try {
      const serviceStatesResponse = await this.listService.getListOptionsByName(
        LIST_CONSTANTS.SERVICE_STATES_LIST_NAME
      );
      if (
        serviceStatesResponse.code === Http.Found &&
        serviceStatesResponse.data !== undefined
      ) {
        serviceStatesResponse.data.forEach(state => {
          this.FieldSelectConfigServiceState.listAll.push({
            id: state.id as string,
            name: state.title as string
          });
        });
        return;
      }
      Snackbar.popInfo(serviceStatesResponse.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  @Watch("FieldListServiceTemplateModel")
  async onSelectServiceTemplateField(value: DynamicSelectData[]) {
    if (await this.isSameServiceOfCondition(value[0].id as string)) {
      Snackbar.popError(
        GENERAL_RULES_CONSTANTS.MESSAGES.NOT_ASSIGN_SAME_SERVICE_OF_CONDITION
      );
    }
  }

  async isSameServiceOfCondition(serviceTemplateId: string) {
    const serviceFieldsInConditions = GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES.find(
      e => e.key == RULES_COLLECTIONS.SERVICES
    )?.fields;
    const serviceTempConditionField = serviceFieldsInConditions?.find(
      e => e.key == SERVICE_FIELDS.TEMPLATE
    )?.field;
    const stateConditionField = serviceFieldsInConditions?.find(
      e => e.key == SERVICE_FIELDS.STATE
    )?.field;
    const valueOfserviceTemp = this.conditions.find(
      e => e.key == serviceTempConditionField
    )?.value[0].key;
    const valueOfState = this.conditions.find(e => e.key == stateConditionField)
      ?.value[0].key;
    return (
      valueOfserviceTemp == serviceTemplateId &&
      valueOfState == SERVICE_STATES.NOT_ASSIGNED
    );
  }
}
